import { useTranslation } from 'next-i18next'
import Image from 'next/image'
import TrustpilotIcon from '../../public/static/trust-pilot-micro.svg'
import Divider from '../divider/Divider'
import { homeUrl } from '../../common/urls/homeUrl'
import Link from 'next/link'

export default function Titles() {
  const { t: booking } = useTranslation('booking')
  return (
    <div className={'flex flex-col items-center'}>
      <h2
        className={
          'text-bold text-color-primary z-20 mx-4 mt-0 text-center font-oswald text-2xl font-medium uppercase md:mt-0 md:text-4xl'
        }
      >
        {booking('bookingPageTitle')}
      </h2>

      <h3
        className={
          'text-lg-normal z-20 mx-4 mb-0 mt-1 text-center text-darul-100 md:mb-1'
        }
      >
        {booking('bookingPageDescription')}
      </h3>

      <Link
        href='https://www.trustpilot.com/review/tapin.gg'
        target='_blank'
        className={'mt-1'}
        rel='noopener noreferrer'
      >
        <Image
          src={TrustpilotIcon}
          width={231}
          height={35}
          className={'object-contain'}
          alt={'Trust pilot icon'}
        />
      </Link>

      <Link className={'btn-v2-primary mt-5 h-12 px-12'} href={homeUrl}>
        Play Now
      </Link>

      <div className={'mt-5 w-full'}>
        <Divider />
      </div>
    </div>
  )
}
